import { z } from 'zod';

import { defaultPagingSchema } from '../../../../helpers/schemas/defaultPagingSchema';
import { getEventsFilterFormSchema } from '../components/EventsFilter/helpers/getEventsFilterFormSchema';
import { EVENT_CATEGORY } from '../const';

const eventsFilterFormSchema = getEventsFilterFormSchema();

export const eventsValidateSearchSchema = defaultPagingSchema.extend({
	category: z.enum(EVENT_CATEGORY).prefault(EVENT_CATEGORY.ALL),
	openedEvent: z.string().optional().catch(undefined),
	filter: eventsFilterFormSchema.optional().catch(undefined),
});

export type EventsValidateSearchSchema = z.infer<
	typeof eventsValidateSearchSchema
>;
